export const mufPersonalisedBagFeatureKey = 'mufPersonalisedBag';
